export type JobDataClassProps = {
    instance_type: string;
};

export interface JobDataInterface {
    instanceType: string;
}

export default class JobData implements JobDataInterface {
    readonly instanceType: string;

    constructor(props: JobDataClassProps) {
        this.instanceType = props.instance_type;
    }
}
